import ReactDOM from 'react-dom/client'
import './index.css'
import 'highlight.js/styles/github.css' // light mode
import 'highlight.js/styles/github-dark.css' // dark mode
import App from './App'
import './i18n'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './store'
import Dialog from './components/dialog'
import AppLoader from './components/fpLoader'
import Workers from './components/worker'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'

import { msalConfig } from './_config/authConfig'
import { Toaster } from 'react-hot-toast'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

const msalInstance = new PublicClientApplication(msalConfig)

root.render(
    <Provider store={store}>
        <Workers />
        <AppLoader />
        <Toaster position="top-center" reverseOrder={false} containerStyle={{ zIndex: 999999 }} toastOptions={{ style: { maxWidth: 1000 } }} />
        <div className="relative">
            <Dialog />
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </div>
    </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
